import { c as _c } from "react/compiler-runtime";
import { Badge, Skeleton } from '@common/components';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { ROUTES } from '@/constants';
import { PREVIEW_SIZE } from '../../constants';
export type PopularPolicySource = 'peer' | 'neighbor';
export interface PopularPolicyData {
  id: string;
  title: string;
  benefit: string;
  source?: PopularPolicySource;
  ddayText: string;
  isUrgent: boolean;
}
interface PopularPoliciesProps {
  policies: PopularPolicyData[];
}
const SOURCE_LABEL: Record<PopularPolicySource, string> = {
  peer: '또래',
  neighbor: '이웃'
};
export function PopularPolicies(t0) {
  const $ = _c(8);
  const {
    policies
  } = t0;
  const isEmpty = policies.length < 1;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="font-700 text-Gray-900 typo-body3">인기 정책</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isEmpty) {
    t2 = isEmpty ? Array.from({
      length: PREVIEW_SIZE
    }, _temp) : null;
    $[1] = isEmpty;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== policies) {
    t3 = policies.map(_temp2);
    $[3] = policies;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <aside className="flex w-250 shrink-0 flex-col gap-8 mobile-tablet:hidden">{t1}{t2}{t3}</aside>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp2(policy) {
  return <CustomLink key={policy.id} href={ROUTES.POLICY_DETAIL.pathname({
    idIdx: policy.id
  })} className="flex w-full cursor-pointer flex-col overflow-hidden rounded-medium border border-Gray-100 bg-Gray-white p-20 transition-colors hover:bg-Gray-25"><div className="flex flex-col gap-2"><div className="flex flex-wrap items-center gap-4">{policy.source && <Badge className={cn("w-fit text-Gray-white", {
          "bg-M-400": policy.source === "peer",
          "bg-Pink-300": policy.source === "neighbor"
        })}>{SOURCE_LABEL[policy.source]}</Badge>}<Badge className={cn("w-fit", {
          "text-Gray-black": !policy.isUrgent,
          "text-R-400": policy.isUrgent
        })}>{policy.ddayText}</Badge></div><p className="truncate font-700 text-Gray-900 typo-body4">{policy.title}</p><div className="h-19"><p className="truncate font-600 text-Gray-550 typo-caption1">{policy.benefit}</p></div></div></CustomLink>;
}
function _temp(_, index) {
  return <PopularPolicySkeleton key={index} />;
}
function PopularPolicySkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex w-full flex-col overflow-hidden rounded-medium border border-Gray-100 bg-Gray-white p-20"><div className="flex flex-col gap-2"><div className="flex items-center gap-4"><Skeleton className="h-20 w-32 rounded-xsmall" /><Skeleton className="h-20 w-40 rounded-xsmall" /></div><Skeleton className="mt-4 h-20 w-full rounded-xxsmall" /><Skeleton className="mt-2 h-19 w-3/4 rounded-xxsmall" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}